module.exports = __webpack_public_path__ + "Img_Add&AddPlus_512px.png";